<template>
  <li>
    <button type="button" :aria-pressed="active ? 'true' : 'false'" :class="{'active': active}" @click="switchFilter(id, label, active)">{{ num ? label.match(/\d+/)[0] : label }}</button>
  </li>
</template>

<script>
import GenericSelector from '@vue-storefront/core/compatibility/components/GenericSelector'
export default {
  props: ['num'],
  mixins: [GenericSelector]
}
</script>
